import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// One place for every route: a new page starts at the top. Back and forward (POP) keep the
// position the browser restores, and anchors scroll to their own target.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType !== 'POP' && !hash) window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); // CSS smooth scrolling would glide up on every new page
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps -- only a path change is a new page

  return null;
}
